module.exports = __webpack_public_path__ + "static/media/ActivitiesIcon.aeb6cb28.svg";